module.exports = __webpack_public_path__ + "static/media/chaturbate.def4ae50.png";